import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const RoleValueContext = createContext<typeof initialState>(initialState);

const RoleActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { RoleActionContext, RoleValueContext };
